<script>
export default {
  page: {
    title: 'Blocked',
    meta: [{ name: 'blocked', content: 'blocked' }],
  },
  components: {},
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
  mounted() {
    if (localStorage.getItem('auth.authDetails') == null) {
      this.$router.push({ name: 'login' })
    }
    window.addEventListener('storage', this.storageChange, null)
  },
  methods: {
    storageChange(event) {
      if (event.key === 'auth.authDetails') {
        // alert('Logged in: ' + event.newValue)
        // if (event.newValue == 'false') {

        window.location.reload()
        // }
      }
    },
    reLogin() {
      localStorage.removeItem('selectedGrpId')
      localStorage.removeItem('selectedOutlet')
      localStorage.removeItem('oloStatus')
      localStorage.removeItem('invEnabledOutlets')
      localStorage.removeItem('promotionOutlets')
      localStorage.removeItem('auth.authDetails')
      localStorage.setItem('relogin', true)
      this.$router.push({ name: 'login' })
    },
  },
}
</script>

<template>
  <div class="app">
    <div class="app flex-row align-items-center">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="0">
            <img
              src="../../assets/images/omakpos360logo.png"
              style="width: 378px; height: 188px; margin-bottom: 20px"
            />
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col md="6">
            <div class="clearfix">
              <h1 class="float-left display-3 mr-4">Blocked</h1>
              <h4 class="pt-3">You are already logged In from another Tab</h4>
              <p class="text-muted">Cannot Use multiple tabs</p>
            </div>
            <div>
              <b-button variant="info" @click="reLogin"> Re-Login </b-button>
            </div>
            <b-input-group hidden>
              <b-input-group-prepend>
                <b-input-group-text>
                  <i class="fa fa-search" />
                </b-input-group-text>
              </b-input-group-prepend>
              <input
                id="prependedInput"
                class="form-control"
                size="16"
                type="text"
                placeholder="What are you looking for?"
              />
              <b-input-group-append>
                <b-button variant="info"> Search </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
